import API from "./api";

/**
 * HRMS API — base path /api/v1/hrms (via axios API_URL).
 * Auth headers are applied globally on the axios instance.
 */

export async function getHrmsDashboard(params = {}) {
  return API.get("hrms/dashboard", { params: params || {} });
}

/* ——— Admin: holidays ——— */
export function hrmsAdminCreateHoliday(body) {
  return API.post("hrms/admin/holidays", body);
}

export function hrmsAdminUpdateHoliday(holidayId, body) {
  return API.put(`hrms/admin/holidays/${holidayId}`, body);
}

export function hrmsAdminDeleteHoliday(holidayId) {
  return API.delete(`hrms/admin/holidays/${holidayId}`);
}

/* ——— Admin: events ——— */
export function hrmsAdminCreateEvent(body) {
  return API.post("hrms/admin/events", body);
}

export function hrmsAdminUpdateEvent(eventId, body) {
  return API.put(`hrms/admin/events/${eventId}`, body);
}

export function hrmsAdminDeleteEvent(eventId) {
  return API.delete(`hrms/admin/events/${eventId}`);
}

/* ——— Admin: announcements ——— */
export function hrmsAdminCreateAnnouncement(body) {
  return API.post("hrms/admin/announcements", body);
}

export function hrmsAdminUpdateAnnouncement(announcementId, body) {
  return API.put(`hrms/admin/announcements/${announcementId}`, body);
}

export function hrmsAdminDeleteAnnouncement(announcementId) {
  return API.delete(`hrms/admin/announcements/${announcementId}`);
}

/* ——— Admin: appreciations ——— */
export function hrmsAdminCreateAppreciation(body) {
  return API.post("hrms/admin/appreciations", body);
}

export function hrmsAdminUpdateAppreciation(appreciationId, body) {
  return API.put(`hrms/admin/appreciations/${appreciationId}`, body);
}

export function hrmsAdminDeleteAppreciation(appreciationId) {
  return API.delete(`hrms/admin/appreciations/${appreciationId}`);
}
